import axios from "axios"
import apiurl from "../../../admin/shared/services/apiendpoint/apiendpoint"
import { gettoken } from "../token/token"

export const saveStudyhallapplication = async(datas) =>{
    try {
        const formData = new FormData();
        for (const key in datas) {
            formData.append(key, datas[key]);
        }
        const token = gettoken();
        const res = await axios.post(`${apiurl()}/study-hall/savestudyhallApplication`,formData,{headers: {"Authorization": `Bearer ${token}`}});
        return res.data
    } catch (error) {
        
    }
}

export const apigetallStudyHallapplications = async (params) => {
    try {
        const token = gettoken();
        const res = await axios.get(`${apiurl()}/study-hall/getstudyhallApplication`,{params:params,headers: { "Authorization": `Bearer ${token}` }});
        return res.data;
    } catch (err) {
        console.log(err);
    }
};

 export const apigetStudyHallFilterOptions = async(data)=>{
    var res=await axios.post(`${apiurl()}/study-hall/getstudyHallfilteroptions`,{field:data},{headers: {"Authorization" : `Bearer ${gettoken()}`}});
    return res.data;
 }